import { ReactElement, ReactNode } from 'react';
import { CheckCircle, Cancel, Error } from '@mui/icons-material';
import { Alert } from '@mui/material';

type AlertType = 'success' | 'error' | 'info';

export interface AlertState {
  type: AlertType;
  text: string;
  isVisible: boolean;
}

const alertIcons: Record<AlertType, ReactElement> = {
  success: <CheckCircle />,
  error: <Cancel />,
  info: <Error />,
};

type AlertProps = { text: ReactNode; type: AlertType; className?: string };

const CustomAlert = ({ text, type, className }: AlertProps) => {
  const icon = alertIcons[type];

  return (
    <Alert severity={type} icon={icon} className={className}>
      {text}
    </Alert>
  );
};

export default CustomAlert;
